import {combineReducers} from "redux";
import modifierParametresReducer from "./modifierParametres";

export default combineReducers({
    modifierParametres : modifierParametresReducer,
});